module.exports = __webpack_public_path__ + "static/assets/42abb1d7b2f41e4a3b994e5b8cf493cf.png";